import * as React from 'react'

import { SVGResponsive } from './common'

function Snacks() {
  return (
    <SVGResponsive height={29} width={24}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M22 19.2881c0 4.5628-4.4772 8.2617-10 8.2617-5.5229 0-10-3.6989-10-8.2617 0-2.3111 1-4.6478 3-5.9 2-1.2522 4.5-1.1224 7 .5299 2.5-1.2392 5.199-1.3103 7-.5299 2.5 1.0832 3 3.5889 3 5.9zM12 12.0498c-.5-2-2-4.5-3.5-6m3.5 6c-.5-4 3.5-7.5 6.5-7 .5 4-3 7.5-6.5 7z"
      />
    </SVGResponsive>
  )
}

export default React.memo(Snacks)
